export enum PaginationDataAs {
  None = 'none',
}
